import user from './reducers/user'
import api from './reducers/api'

export const reducerList = {
  user,
  api
}

export default reducerList
